import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { PedidoConsultaInternaOutput } from "src/app/@shared/models/consulta-detalhes-interno";
import { StorageService } from "src/app/services/storage/storage.service";
import { DetalheFormularioInternoComponent } from "./bloco-busca/detalhe-formulario-interno/detalhe-formulario-interno.component";

@Component({
  selector: "app-consulta-detalhada-interna",
  templateUrl: "./consulta-detalhada-interna.component.html",
  styleUrls: ["./consulta-detalhada-interna.component.scss"],
})
export class ConsultaDetalhadaInternaComponent implements OnInit {
  public external = StorageService.getExternalAccess();
  isLoading: Boolean;
  cliente: any;
  urlParams: any;
  tabIndex: any;

  pedido: PedidoConsultaInternaOutput;
  @ViewChild("formulariobusca") formPesquisa: DetalheFormularioInternoComponent;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public snackBar: MatSnackBar
  ) {}

  ngAfterViewInit() {
    this.formPesquisa.onSearchResult.subscribe(
      (pedido: PedidoConsultaInternaOutput) => {
        this.pedido = pedido;
        this.isLoading = false;
      }
    );

    this.formPesquisa.onLoadingChange.subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.urlParams = { ...params };
    });
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  novaConsulta() {
    window.location.reload();
  }
}
